module.exports = __webpack_public_path__ + "img/4631948.65f613dc.jpg";